import React from "react";
import './FinancialGuarantor.css';

class FinancialGuarantor extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">الضامن المالى فى ألمانيا</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        السلام عليكم يا شباب مقال مهم وشامل كل الاسئله المتعلقه بالموضوع
                                        <br/>
                                        #اعادة_نشر 
                                        <br/>
                                        كل شئ عن الكفاله الشخصيه " الضامن المالى " المتاح تقديمها للسفاره الالمانيه من اجل الفيزا !
                                        <br/>
                                        <br/>
                                        س1 ماهي الكفاله الشخصيه؟
                                        <br/>
                                        هي ورقه verpflichtungserklaerung
                                        <br/>
                                        يتم التوقيع عليها لدي دائره الاجانب في المانيا تخلي بموجبها السلطات الالمانيه أي مسؤليه ماديه تجاه المكفول وتحيل هذه المسؤليه الي الكفيل حسب القانون Aufenthaltsgesetz 68-66
                                        <br/>
                                        فالقانون الالماني يضمن لكل من يعيش في المانيا الحقوق الاساسيه للانسان من ماكل ومشرب وغيرها .. الخ بغض النظر عن الجنسيه او الديانه او غير ذالك فان حدث للقادم أي تعثر مادي او ماشابه ذالك فالمسؤول هوا الكفيل وليست الحكومه الالمانيه وعلي هذا يتم التوقيع!!
                                        <br/>
                                        لمعرفه المزيد من المعلومات موجوده في <a target='_blank' rel='noreferrer' href='https://www.auswaertiges-amt.de/de/service/fragenkatalog-node/13-verpflichtungserklaerung/606492'>الرابط</a> ده
                                        <br/>
                                        <br/>
                                        س2 لاي نوع من انواع الفيزا تصلح الكفاله الشخصيه ؟
                                        <br/>
                                        الكفاله الشخصيه صالحه لجميع انواع الفيزا
                                        <br/>
                                        <br/>
                                        س3 ماهي الشروط التي يطلبها مكتب الاجانب من الكفيل؟
                                        <br/>
                                        والمكفول ايضا .. يتم تحديد الدخل بواسطة مكتب الاجانب
                                        <br/>
                                        <br/>
                                        س4 ماعدد الاشخاص المتاح كفالتهم بنفس الوقت ؟
                                        <br/>
                                        العدد متعلق بدخل الكفيل وحالته الاجتماعيه اعزب او متزوج اوغير ذالك ومكتب الاجانب يحدد العدد بعد فحص اوراق الكفيل.
                                        <br/>
                                        <br/>
                                        س5 هل يشترط ان يكون الكفيل الماني الجنسيه او لديه اقامه دائمه في المانيا ؟
                                        <br/>
                                        حاليا منذ بداية 2017 .. السفارة تشترط ان يكون الكفيل يعيش فى المانيا مهما كانت جنسيته ولا يعترفوا بالكفيل الذى يعيش خارج المانيا
                                        <br/>
                                        <br/>
                                        س6 هل يستطيع شخص لا يمت لي بصله قرابه ان يكفلني ؟
                                        <br/>
                                        نعم يستطيع ذالك 
                                        <br/>
                                        <br/>
                                        س7 ماهي المده اللتي يستغرقها الكفيل لاتمام الاجراءات للكفاله ؟
                                        <br/>
                                        عاده يذهب الكفيل لمكتب الاجانب للمدينة الذى يعيش بها و يسأل على الاوراق المطلوبة  منه و من المكفول ويوقع علي الورقه ف الحال بعد فحص اوراقه من قبل الموظف هناك.
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        = ملحوظه
                                        <br/>
                                        - الكفاله الشخصيه لا يمكن لاحد بيعها لانه ببساطه يمكن للمكفول ان يطالب الكفيل بالنفقه عليه طيله دراسته كما التزم بذالك امام القانون. فهل يمكن لاحد قبض ولو عده الاف من اليوروهات ويصبح ملزم امام القانون بالنفقه ودفع عشرات اضعاف هذا المبلغ؟
                                        <br/>
                                        - الكفيل لا يدفع اى تكاليف اضافية اثناء استخراج الورقة و يدفع فقط مصاريف الورقة و التى تتراوح ما بين 20 ل 30 يورو 
                                        <br/>
                                        - عند استلام الكفيل الورقة فيرسلها الى المكفول بواسطة شركات الشحن او بواسطة البريد الالكترونى و يسلم المكفول نسخة منها "ليست الاصل " عند دخوله السفارة 
                                        <br/>
                                        - مدة الكفالة تكون غالبا على حسب المدة التى يحددها الكفيل للمكفول وليكن سنتين او 3 او 4 سنين .. لعدم تكرار استخراجها كل سنة
                                        <br/>
                                        - الفترة الاخيرة فى السفارة الالمانية فى القاهرة بيرفضوا الضامن المالى من خارج المانيا حتى لو فى اى دولة اوروبية او فى مصر .. لو حد مفيش اودامه حل غير ضامن خارج المانيا فالافضل انك ترسل للسفارة و تستفسر منهم وتعرفهم ظروف الضامن دة ايه.
                                        <br/>
                                        - لو تعرف حد فى المانيا و بيشتغل ف دى الحاجة الوحيدة اللى يقدر يساعدك بيها
                                        <br/>
                                        - مش لازم تسافر على المدينة اللى فيها الضامن المالى . بمعنى لو الضامن فى برلين و انت جامعتك فى ميونيخ . ف دة مش هيبقا عائق ومش هيبقا فيها مشكلة
                                        <br/>
                                        - ورقة الضامن المالى تلغى الحساب البنكى والاتنين واحد بالنسبة للسفارة
                                        <br/>
                                        - الضامن المالى كل فكرتها ان هى بتلغى الحساب البنكى لان  الحساب بالنسبة لشباب كتيرة بيبقا صعب تجميعه مرة واحدة بس لما تسافر المانيا .. معظم الشباب بتسافر و بتصرف على نفسها ومبيحتاجوش حاجة من الضامن
                                        <br/>
                                        - الضامن المالى مسئول امام  الحكومة الالمانية ان هو متكفل بكل حاجة من الناحية المادية .. عشان كدة محدش يقدر يبيعها بفلوس و مش اى حد بيوافق يعملها الا اذا كان عارفك
                                        <br/>
                                        الشرط الاساسي هو ان يكون للكفيل دخل جيد يكفي الكفيل ومن يعيلهم
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default FinancialGuarantor;
